import { type ReactElement } from 'react';
import { getSvgIconId } from '../../Util/getSvgIconId';

export default function PopupTemplateWrapper({
    children,
    iconId,
    title,
}: {
    children: JSX.Element;
    iconId: number | string;
    title: string;
}): ReactElement {
    return (
        <div className="popup">
            <div className="popup__header d-flex justify-content-between align-items-center py-2 ps-3 pe-2">
                <div className="popup__header-icon me-2">
                    <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <use xlinkHref={getSvgIconId(iconId)}></use>
                    </svg>
                </div>
                <h3 className="mb-0 flex-grow-1">{title}</h3>
                <button className="close-button unstyled-button" type="button">
                    <span className="visually-hidden">Stäng</span>
                    <svg
                        className="svg-icon"
                        aria-hidden="true"
                        focusable="false"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                        <use xlinkHref={getSvgIconId('close')}></use>
                    </svg>
                </button>
            </div>
            <div className="popup__content px-3 py-2">{children}</div>
        </div>
    );
}
